import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next--sprite",
  "use": "next--sprite-usage",
  "viewBox": "0 0 105 155",
  "content": "<symbol viewBox=\"0 0 105 155\" id=\"next--sprite\">\n<path d=\"M98.1333 82.2448L104.387 93.9065L6.26186 155L-0.000472002 143.329L98.1333 82.2448Z\" />\n<path d=\"M6.29378 -9.46163e-07L-0.000467454 12.2244L98.0925 75.918L104.387 63.6844L6.29378 -9.46163e-07Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol